export {default} from './EditUser';



// WEBPACK FOOTER //
// ./src/pages/EditUser/index.ts